import React from "react";
import type { MenuButtonProps } from "@chakra-ui/react";
import { MenuButton as MenuButtonChakra } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { colors } from "../../../../../../theme/colors";
import { css } from '@emotion/react';

const MenuButton: React.FC<MenuButtonProps> = observer(({ children, ...rest }) => (
	<MenuButtonChakra
		p={2}
		transition="all 0.2s"
		fontSize={"18px"}
    lineHeight="24px"
    fontWeight={400}
		style={{ margin: 0 }}
		textColor={colors.black[500]}
		{...rest}
	>
		{children}
	</MenuButtonChakra>
));

export default MenuButton;
